import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import metricsApi from '../services/metricsApi';
import '../css/PredictionPage.css';

const PredictionPage = () => {
    const location = useLocation();
    const { symbol } = useParams();
    const navigate = useNavigate();
    const [predictionData, setPredictionData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [activeTab, setActiveTab] = useState(0);

  // Parse URL parameters
    const searchParams = new URLSearchParams(location.search)
    //const ticker = searchParams.get('symbol') || 'MSFT';
    const period = searchParams.get('period') || '3mo';
    const prediction_days = parseInt(searchParams.get('prediction_days')) || 30;
    const include_news = searchParams.get('include_news') === 'true';
    const risk_tolerance = parseInt(searchParams.get('risk_tolerance')) || 50;

  const params = {
    ticker: searchParams.get('symbol') || 'MSFT',
    period: searchParams.get('period') || '1y',
    prediction_days: parseInt(searchParams.get('prediction_days')) || 30,
    include_news: searchParams.get('include_news') === 'true',
    risk_tolerance: parseInt(searchParams.get('risk_tolerance')) || 50
  };

  console.info(" Input Symbol: ", symbol);
  console.info(" Input Params: ", params);


  useEffect(() => {
    const fetchPrediction = async () => {
      try {
        setLoading(true);
        // const queryString = new URLSearchParams({
        //   ticker: params.ticker,
        //   period: params.period,
        //   prediction_days: params.prediction_days,
        //   include_news: params.include_news,
        //   risk_tolerance: params.risk_tolerance
        // }).toString();

        // const response = await fetch(`/api/predict?${queryString}`);
        const predictionsResponse = await metricsApi.getPredictions(symbol, period, prediction_days, include_news, risk_tolerance);

        console.info("Prediction Data: ", predictionsResponse)
        
        if (!predictionsResponse) {
          throw new Error('Failed to generate prediction');
        }
        

        const data = await predictionsResponse;
        setPredictionData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };


    if (params.ticker) {
      fetchPrediction();
    }
        
  }, [location.search]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner-large"></div>
        <div className="loading-text">
          Generating prediction for {params.ticker}...
        </div>
      </div>
    );
  }
  console.info("Error : ", error);
  if (error) {
    return (
      <div className="error-container">
        <div className="error-card">
          <div className="error-icon">⚠️</div>
          <div className="error-content">
            <h3>Prediction Error</h3>
            <p>{error}</p>
            <button 
              className="back-button"
              onClick={() => navigate('/search')}
            >
              ← Back to Search
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!predictionData) {
    return (
      <div className="error-container">
        <div className="error-card">
          <div className="error-icon">📊</div>
          <div className="error-content">
            <h3>No Data Available</h3>
            <p>No prediction data available. Please try another search.</p>
            <button 
              className="back-button"
              onClick={() => navigate('/search')}
            >
              ← Back to Search
            </button>
          </div>
        </div>
      </div>
    );
  }

  const {
    ticker,
    company_name,
    current_price,
    prediction,
    confidence,
    historical_data,
    prediction_chart_data,
    risk_assessment,
    news_sentiment,
    technical_indicators
  } = predictionData;

  // Mock chart data for demonstration
  const chartData = [
    { date: '2024-01', actual: 150, predicted: null },
    { date: '2024-02', actual: 155, predicted: null },
    { date: '2024-03', actual: 160, predicted: null },
    { date: '2024-04', actual: 158, predicted: null },
    { date: '2024-05', actual: 165, predicted: null },
    { date: '2024-06', actual: null, predicted: 170 },
    { date: '2024-07', actual: null, predicted: 175 },
    { date: '2024-08', actual: null, predicted: 180 },
  ];

  const tabs = [
    { id: 0, label: 'Prediction Overview', icon: '📊' },
    { id: 1, label: 'Technical Analysis', icon: '📈' },
    { id: 2, label: 'Risk Assessment', icon: '🛡️' },
    { id: 3, label: 'News & Sentiment', icon: '📰' }
  ];

  return (
    <div className="prediction-container">
      {/* Header */}
      <div className="prediction-header">
        <button
          className="back-button"
          onClick={() => navigate('/search')}
        >
          ← Back to Search
        </button>
        <div className="header-content">
          <h1 className="prediction-title">
            {symbol} - {company_name}
          </h1>
          <p className="prediction-subtitle">
            Prediction Analysis • {params.prediction_days}-day forecast
          </p>
        </div>
      </div>

      {/* Tabs */}
      <div className="tabs-container">
        <div className="tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab ${activeTab === tab.id ? 'tab-active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === 0 && (
          <div className="overview-grid">
            {/* Key Metrics */}
            <div className="metrics-grid">
              <div className="metric-card">
                <div className="metric-icon">💰</div>
                <div className="metric-content">
                  <div className="metric-label">Current Price</div>
                  <div className="metric-value">${current_price}</div>
                </div>
              </div>

              <div className="metric-card">
                <div className="metric-icon">🎯</div>
                <div className="metric-content">
                  <div className="metric-label">Predicted Price</div>
                  <div className={`metric-value ${
                    prediction.price_change >= 0 ? 'positive' : 'negative'
                  }`}>
                    ${prediction.predicted_price}
                  </div>
                  <div className={`metric-change ${
                    prediction.price_change >= 0 ? 'positive' : 'negative'
                  }`}>
                    {prediction.price_change >= 0 ? '↗' : '↘'} 
                    {prediction.price_change >= 0 ? '+' : ''}{prediction.price_change}%
                  </div>
                </div>
              </div>

              <div className="metric-card">
                <div className="metric-icon">🎲</div>
                <div className="metric-content">
                  <div className="metric-label">Confidence Level</div>
                  <div className="metric-value">{confidence}%</div>
                  <div className={`confidence-badge ${
                    confidence >= 80 ? 'high' : 
                    confidence >= 60 ? 'medium' : 'low'
                  }`}>
                    {confidence >= 80 ? 'High' : confidence >= 60 ? 'Medium' : 'Low'}
                  </div>
                </div>
              </div>

              <div className="metric-card">
                <div className="metric-icon">⚠️</div>
                <div className="metric-content">
                  <div className="metric-label">Risk Level</div>
                  {/* <div className="metric-value">{risk_assessment.level}</div>
                  <div className={`risk-badge ${
                    risk_assessment.level === 'Low' ? 'low' : 
                    risk_assessment.level === 'Medium' ? 'medium' : 'high'
                  }`}>
                    {risk_assessment.level}
                  </div> */}
                </div>
              </div>
            </div>

            {/* Prediction Chart */}
            <div className="chart-card">
              <div className="card-header">
                <h3 className="card-title">Price Prediction Chart</h3>
              </div>
              <div className="chart-container">
                <div className="chart">
                  {chartData.map((point, index) => (
                    <div key={index} className="chart-point">
                      <div className="chart-line"></div>
                      <div className={`chart-dot ${
                        point.actual ? 'actual' : 'predicted'
                      }`}></div>
                      <div className="chart-label">{point.date}</div>
                      <div className="chart-value">
                        {point.actual ? `$${point.actual}` : `$${point.predicted}`}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="chart-legend">
                  <div className="legend-item">
                    <div className="legend-color actual"></div>
                    <span>Historical Price</span>
                  </div>
                  <div className="legend-item">
                    <div className="legend-color predicted"></div>
                    <span>Predicted Price</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Recommendation */}
            <div className="recommendation-card">
              <div className="card-header">
                <h3 className="card-title">💡 Investment Recommendation</h3>
              </div>
              <div className="recommendation-content">
                <p className="recommendation-text">
                  {prediction.recommendation || 
                   `Based on our analysis, we recommend a ${
                     prediction.price_change >= 0 ? 'BUY' : 'HOLD'
                   } position for ${symbol}. The stock shows ${
                     prediction.price_change >= 0 ? 'strong upward' : 'moderate downward'
                   } momentum with ${confidence}% confidence.`}
                </p>
                <div className="recommendation-tags">
                  <span className="tag">Time Horizon: {params.prediction_days} days</span>
                  <span className="tag">Risk Tolerance: {params.risk_tolerance}/100</span>
                  <span className="tag">
                    News Analysis: {params.include_news ? 'Enabled' : 'Disabled'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 1 && (
          <div className="technical-analysis">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Technical Indicators</h3>
              </div>
              <div className="indicators-grid">
                <div className="indicator">
                  <span className="indicator-label">RSI (14)</span>
                  <span className="indicator-value">62.5</span>
                  <div className="indicator-bar">
                    <div 
                      className="indicator-fill neutral"
                      style={{ width: '62.5%' }}
                    ></div>
                  </div>
                </div>
                <div className="indicator">
                  <span className="indicator-label">MACD</span>
                  <span className="indicator-value positive">+2.34</span>
                  <div className="indicator-bar">
                    <div 
                      className="indicator-fill positive"
                      style={{ width: '70%' }}
                    ></div>
                  </div>
                </div>
                <div className="indicator">
                  <span className="indicator-label">Moving Avg (50)</span>
                  <span className="indicator-value positive">$158.23</span>
                  <div className="indicator-bar">
                    <div 
                      className="indicator-fill positive"
                      style={{ width: '80%' }}
                    ></div>
                  </div>
                </div>
                <div className="indicator">
                  <span className="indicator-label">Volume</span>
                  <span className="indicator-value">45.2M</span>
                  <div className="indicator-bar">
                    <div 
                      className="indicator-fill neutral"
                      style={{ width: '65%' }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 2 && (
          <div className="risk-assessment">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Risk Analysis</h3>
              </div>
              <div className="risk-content">
                <div className="risk-meter">
                  <div className="meter-labels">
                    <span>Low Risk</span>
                    <span>Medium Risk</span>
                    <span>High Risk</span>
                  </div>
                  <div className="meter-bar">
                    {/* <div 
                      className={`meter-fill ${risk_assessment.level.toLowerCase()}`}
                      style={{ 
                        width: risk_assessment.level === 'Low' ? '33%' : 
                               risk_assessment.level === 'Medium' ? '66%' : '100%' 
                      }}
                    ></div> */}
                  </div>
                </div>
                <div className="risk-factors">
                  <h4>Key Risk Factors:</h4>
                  <ul>
                    <li>Market volatility: Medium</li>
                    <li>Sector performance: Strong</li>
                    <li>Company fundamentals: Good</li>
                    <li>Economic outlook: Stable</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 3 && (
          <div className="news-sentiment">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">News & Market Sentiment</h3>
              </div>
              <div className="sentiment-content">
                <div className="sentiment-score">
                  <div className="score-card positive">
                    <div className="score-value">72%</div>
                    <div className="score-label">Positive Sentiment</div>
                  </div>
                </div>
                <div className="news-feed">
                  <h4>Recent News Headlines:</h4>
                  <div className="news-items">
                    <div className="news-item">
                      <div className="news-title">Strong Quarterly Earnings Report</div>
                      <div className="news-source">Financial Times</div>
                      <div className="news-sentiment positive">Positive</div>
                    </div>
                    <div className="news-item">
                      <div className="news-title">New Product Launch Announcement</div>
                      <div className="news-source">TechCrunch</div>
                      <div className="news-sentiment positive">Positive</div>
                    </div>
                    <div className="news-item">
                      <div className="news-title">Market Volatility Concerns</div>
                      <div className="news-source">Bloomberg</div>
                      <div className="news-sentiment neutral">Neutral</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PredictionPage;